import React, { useEffect, useState } from "react";
import { getFullAuditLog } from "../../services/generic";
import { useParams } from "react-router-dom";
import { Drawer, Table, Button } from "antd";
import backIcon from "../../assets/images/close-x.svg";

const FullAuditLog = () => {
  const { recordId, windowId } = useParams();
  const [open, setOpen] = useState(false);
  const [auditData, setAuditData] = useState([]);

  useEffect(() => {
    const fetchAuditLog = async () => {
      try {
        const response = await getFullAuditLog(windowId, recordId);
        // ensure it's array
        setOpen(true)
        setAuditData(Array.isArray(response) ? response : [response]);
      } catch (err) {
        console.error("Error fetching audit logs:", err);
      }
    };
    fetchAuditLog();
  }, [windowId, recordId]);

  const columns = [
    {
      title: "Tab Name",
      dataIndex: "tab_name",
      key: "tab_name",
      width:100
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width:100
    },
    {
      title: "Field Changed",
      dataIndex: "field_changed",
      key: "field_changed",
      width:100
    },
    {
      title: "Old Value",
      dataIndex: "old_value",
      key: "old_value",
      width:100
    },
    {
      title: "New Value",
      dataIndex: "new_value",
      key: "new_value",
      width:100
    },
    {
      title: "Changed By",
      dataIndex: "changed_by",
      key: "changed_by",
      width:100
    },
    {
      title: "Changed At",
      dataIndex: "changed_at",
      key: "changed_at",
      width:100,
      render: (val) => new Date(val).toLocaleString(), // format date
    },
    
    
  ];

  return (
    <>
      {/* <Button type="primary" onClick={() => setOpen(true)}>
        View Audit Logs
      </Button> */}
      <Drawer
      closeIcon={null}
      closable={false}
       title={
         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontFamily: 'Inter', padding: "1% 2%" }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                                style={{
                                    display: 'inline-block',
                                    marginTop: '3px',
                                    width:"2vw",
                                    marginRight: '8px',
                                    cursor: 'pointer',

                                }}
                                src={backIcon}
                                onClick={()=>{setOpen(false)}}
                                alt="AuditTrail"
                            />
                            <h2 style={{ fontWeight: 600, fontSize: '20px', margin: 0 }}>Full Audit Log</h2>
                        </div>
                    </div>           
                }
        placement="right"
        width={910}
        onClose={() => setOpen(false)}
        visible={open}
      >
        <Table
          size="small"
          rowKey={(record, idx) => idx}
          dataSource={auditData}
          columns={columns}
          pagination={false}
        //   pagination={{ pageSize: 5 }}
        />
      </Drawer>
    </>
  );
};

export default FullAuditLog;
